import { NgModule } from '@angular/core';
import { OrderStoreModule } from './store/order-store.module';

@NgModule({
  imports: [OrderStoreModule],
})
export class OrderDataAccessModule {}
